import { InjectionToken } from '@angular/core';
import {
  AutoRegistrationConfig,
  AutoRegistrationRoutesConfig,
} from './models/auto-registration-config';

/** Route segment names for registration (used by router + `CONFIG`). */
export const registrationRoutesConfig: AutoRegistrationRoutesConfig = {
  LOGIN: 'login',
  SIGNUP: 'registration-cycle',
  RESET_PASSWORD: 'reset-password',
  VERIFY: 'verify',
  CHOOSE_BUSINESS_3: 'choose-business-3',
  CHOOSE_BUSINESS_4: 'choose-business-4',
  CHOOSE_BUSINESS_5: 'choose-business-5',
  SMART_SUGGESTIONS: 'smart-suggestions',
};

/** Injected registration app config (provided in `AppModule`). */
export const CONFIG = new InjectionToken<AutoRegistrationConfig>('RegistrationConfig');
